var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('collapsable-card',{attrs:{"title":_vm.$t('app.general.title.retract'),"icon":"$retract","draggable":true,"layout-path":"dashboard.retract-card"}},[_c('retract')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }